import type { IconNode } from '../types';

/**
 * @name cloth
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA1YTEuNDEgMS40MSAwIDAgMCAwIDJsMSAxYTEuNDEgMS40MSAwIDAgMSAwIDJsLTEgMWExLjQxIDEuNDEgMCAwIDAgMCAybDEgMWExLjQxIDEuNDEgMCAwIDEgMCAybC0xIDFhMS40MSAxLjQxIDAgMCAwIDAgMmwyIDJhMS40MSAxLjQxIDAgMCAwIDIgMGwxLTFhMS40MSAxLjQxIDAgMCAxIDIgMGwxIDFhMS40MSAxLjQxIDAgMCAwIDIgMGwxLTFhMS40MSAxLjQxIDAgMCAxIDIgMGwxIDFhMS40MSAxLjQxIDAgMCAwIDIgMGwyLTJhMS40MSAxLjQxIDAgMCAwIDAtMmwtMS0xYTEuNDEgMS40MSAwIDAgMSAwLTJsMS0xYTEuNDEgMS40MSAwIDAgMCAwLTJsLTEtMWExLjQxIDEuNDEgMCAwIDEgMC0ybDEtMWExLjQxIDEuNDEgMCAwIDAgMC0ybC0yLTJhMS40MSAxLjQxIDAgMCAwLTIgMGwtMSAxYTEuNDEgMS40MSAwIDAgMS0yIDBsLTEtMWExLjQxIDEuNDEgMCAwIDAtMiAwbC0xIDFhMS40MSAxLjQxIDAgMCAxLTIgMEw3IDNhMS40MSAxLjQxIDAgMCAwLTIgMFoiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/cloth
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cloth: IconNode = [
  [
    'path',
    {
      d: 'M3 5a1.41 1.41 0 0 0 0 2l1 1a1.41 1.41 0 0 1 0 2l-1 1a1.41 1.41 0 0 0 0 2l1 1a1.41 1.41 0 0 1 0 2l-1 1a1.41 1.41 0 0 0 0 2l2 2a1.41 1.41 0 0 0 2 0l1-1a1.41 1.41 0 0 1 2 0l1 1a1.41 1.41 0 0 0 2 0l1-1a1.41 1.41 0 0 1 2 0l1 1a1.41 1.41 0 0 0 2 0l2-2a1.41 1.41 0 0 0 0-2l-1-1a1.41 1.41 0 0 1 0-2l1-1a1.41 1.41 0 0 0 0-2l-1-1a1.41 1.41 0 0 1 0-2l1-1a1.41 1.41 0 0 0 0-2l-2-2a1.41 1.41 0 0 0-2 0l-1 1a1.41 1.41 0 0 1-2 0l-1-1a1.41 1.41 0 0 0-2 0l-1 1a1.41 1.41 0 0 1-2 0L7 3a1.41 1.41 0 0 0-2 0Z',
      key: 'dt70q6',
    },
  ],
];

export default cloth;
